export default [
  {
    title: 'breadcrumb.store',
    route: 'list-store',
    icon: 'ShoppingCartIcon',
    resource: 'store',
    action: 'read',
  },
]
